export default "__VITE_ASSET__CuNPLR_e__"